import FunderActionTypes from "./funder.types";

/** ***************** GET FUNDER LIST START *********************** */
export const getFunderListStart = (getData: any) => ({
  type: FunderActionTypes.GET_FUNDER_LIST_START,
  payload: getData,
});

export const getFunderListSuccess = (successData: any) => ({
  type: FunderActionTypes.GET_FUNDER_LIST_SUCCESS,
  payload: successData,
});

export const getFunderListFailure = (failureData: any) => ({
  type: FunderActionTypes.GET_FUNDER_LIST_FAILURE,
  payload: failureData,
});

export const getFunderListResponseResetStart = () => ({
  type: FunderActionTypes.GET_FUNDER_LIST_RESPONSE_RESET,
});

export const getFunderListResponseChanged = () => ({
  type: FunderActionTypes.GET_FUNDER_LIST_RESPONSE_CHANGED,
});

/** ***************** GET FUNDER LIST END *********************** */

/** ***************** ADD FUNDER DETAILS START *********************** */
export const addFunderDetailsStart = (addData: any) => ({
  type: FunderActionTypes.ADD_FUNDER_DETAILS_START,
  payload: addData,
});

export const addFunderDetailsSuccess = (successData: any) => ({
  type: FunderActionTypes.ADD_FUNDER_DETAILS_SUCCESS,
  payload: successData,
});

export const addFunderDetailsFailure = (failureData: any) => ({
  type: FunderActionTypes.ADD_FUNDER_DETAILS_FAILURE,
  payload: failureData,
});

export const addFunderDetailsResponseResetStart = () => ({
  type: FunderActionTypes.ADD_FUNDER_DETAILS_RESPONSE_RESET,
});

export const addFunderDetailsResponseChanged = () => ({
  type: FunderActionTypes.ADD_FUNDER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD FUNDER DETAILS END *********************** */

/** ***************** UPDATE FUNDER DETAILS START *********************** */
export const updateFunderDetailsStart = (updateData: any) => ({
  type: FunderActionTypes.UPDATE_FUNDER_DETAILS_START,
  payload: updateData,
});

export const updateFunderDetailsSuccess = (successData: any) => ({
  type: FunderActionTypes.UPDATE_FUNDER_DETAILS_SUCCESS,
  payload: successData,
});

export const updateFunderDetailsFailure = (failureData: any) => ({
  type: FunderActionTypes.UPDATE_FUNDER_DETAILS_FAILURE,
  payload: failureData,
});

export const updateFunderDetailsResponseResetStart = () => ({
  type: FunderActionTypes.UPDATE_FUNDER_DETAILS_RESPONSE_RESET,
});

export const updateFunderDetailsResponseChanged = () => ({
  type: FunderActionTypes.UPDATE_FUNDER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE FUNDER DETAILS END *********************** */

/** ***************** DELETE FUNDER DETAILS START *********************** */
export const deleteFunderDetailsStart = (deleteData: any) => ({
  type: FunderActionTypes.DELETE_FUNDER_DETAILS_START,
  payload: deleteData,
});

export const deleteFunderDetailsSuccess = (successData: any) => ({
  type: FunderActionTypes.DELETE_FUNDER_DETAILS_SUCCESS,
  payload: successData,
});

export const deleteFunderDetailsFailure = (failureData: any) => ({
  type: FunderActionTypes.DELETE_FUNDER_DETAILS_FAILURE,
  payload: failureData,
});

export const deleteFunderDetailsResponseResetStart = () => ({
  type: FunderActionTypes.DELETE_FUNDER_DETAILS_RESPONSE_RESET,
});

export const deleteFunderDetailsResponseChanged = () => ({
  type: FunderActionTypes.DELETE_FUNDER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE FUNDER DETAILS END *********************** */

/** ***************** FETCH FUNDER DETAILS START *********************** */
export const fetchFunderDetailsStart = (fetchData: any) => ({
  type: FunderActionTypes.FETCH_FUNDER_DETAILS_START,
  payload: fetchData,
});

export const fetchFunderDetailsSuccess = (successData: any) => ({
  type: FunderActionTypes.FETCH_FUNDER_DETAILS_SUCCESS,
  payload: successData,
});

export const fetchFunderDetailsFailure = (failureData: any) => ({
  type: FunderActionTypes.FETCH_FUNDER_DETAILS_FAILURE,
  payload: failureData,
});

export const fetchFunderDetailsResponseResetStart = () => ({
  type: FunderActionTypes.FETCH_FUNDER_DETAILS_RESPONSE_RESET,
});

export const fetchFunderDetailsResponseChanged = () => ({
  type: FunderActionTypes.FETCH_FUNDER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH FUNDER DETAILS END *********************** */

/** ******************** FUNDER LIST FETCH START **************** */
export const funderListFetchStart = (funderList: any) => ({
  type: FunderActionTypes.FUNDER_LIST_FETCH_START,
  payload: funderList,
});

export const funderListFetchSuccess = (success: any) => ({
  type: FunderActionTypes.FUNDER_LIST_FETCH_SUCCESS,
  payload: success,
});

export const funderListFetchFailure = (failure: any) => ({
  type: FunderActionTypes.FUNDER_LIST_FETCH_FAILURE,
  payload: failure,
});

export const funderListResponseResetStart = () => ({
  type: FunderActionTypes.FUNDER_LIST_RESPONSE_RESET_START,
});

export const funderListFetchResponseChanged = () => ({
  type: FunderActionTypes.FUNDER_LIST_FETCH_RESPONSE_CHANGED,
});
/** ******************** FUNDER LIST FETCH END **************** */